import { NavItem, NavItemWithChildrenType } from '../../../types';

export function isEmptyNavItem(navLink: NavItem) {
  const parentNav = navLink as NavItemWithChildrenType;
  return parentNav?.children === undefined || parentNav.children.length === 0;
}
